import withSequenceState from 'components/hoc/withSequenceState';
import { WithSequenceStatePropsType } from 'components/hoc/withSequenceState';
import CardDetailRecommendation from 'components/molecules/Card/Detail/Recommendation';
import { CardDetailPropsType } from 'components/molecules/Card/Fragments/CardDetail';
import Sequences from 'defs/sequences';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
	actionCreators,
	getButtonLink,
	getHasButtonLink,
	getImages,
	getInfoText,
	getIsDone,
	getItemContentVideo,
	getText,
	getTitle,
} from 'store/programItems';
import { RootStateType } from 'store/programItems';

export type ButtonLinkType = ReturnType<typeof getButtonLink>;
export type LinkListType = {
	modifier: string;
	links: Array<ButtonLinkType>;
};

export type StateToPropsType = {
	title: ReturnType<typeof getTitle>;
	isDone: ReturnType<typeof getIsDone>;
	contentVideo: ReturnType<typeof getItemContentVideo>;
	linkList?: LinkListType;
	images: ReturnType<typeof getImages>;
	text: ReturnType<typeof getText>;
	infoText: ReturnType<typeof getInfoText>;
};
export type DispatchToPropsType = typeof actionCreators;

const mapStateToProps = (state: RootStateType, ownProps: CardDetailPropsType): StateToPropsType => ({
	title: getTitle(state, ownProps.id),
	isDone: getIsDone(state, ownProps.id),
	contentVideo: getItemContentVideo(state, ownProps.id),
	linkList: getHasButtonLink(state, ownProps.id)
		? { modifier: 'center', links: [getButtonLink(state, ownProps.id)] }
		: undefined,
	images: getImages(state, ownProps.id),
	text: getText(state, ownProps.id),
	infoText: getInfoText(state, ownProps.id),
});

const mapDispatchToProps = (dispatch): DispatchToPropsType => {
	return bindActionCreators(actionCreators, dispatch);
};

export type ContainerCardDetailRecommendationPropsType = CardDetailPropsType &
	StateToPropsType &
	DispatchToPropsType &
	WithSequenceStatePropsType;

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withSequenceState(CardDetailRecommendation, [Sequences.CARD_IS_CHECKING]) as any);
